import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal, ModalBody } from "react-bootstrap";
import isNull from '../../../../../../../../../../../../utils/NullChecking'
import { ServerRequestProtected } from '../../../../../../../../../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../../../../../../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../../../../../../../../../utils/Enum';
import FormValidator from '../../../../../../../../../../../../utils/FormValidator';
import DatePicker from '../../../../../../../../../../../General/DatePicker';
import ModalHeader from '../../../../../../../../../../../Setup/Shared/ModalHeader';
import SuperSearchList from '../../../../../../../../../../../shared/SuperSearch/SuperSearchList';
import { SexualOrientation as SexualOrientationData} from '../../../../../../../../../../../../utils/Constants';
import DeleteConfirmatiom from '../../../../../../../../../../../General/DeleteConfirmation';
import Loader from '../../../../../../../../../../../shared/Loader/Loader';

const AddNewSexualOrientation = (props) => {
    const { isOpenSexualOrientation, onClose, sexualOrientationData, setIsRecordSaved, patientID, IsEditAllowed, onDeleteSexualOrientation } = { ...props }
    const API_URL = enumUtil.controller.General
    let SexualOrientation_Modal = {
        SexualOrientation: sexualOrientationData?.SexualOrientation || "",
        Notes: sexualOrientationData?.Notes || "",
    }
    let valModal = {}
    let ValidationModal = {
        SexualOrientationVal: "",
        NotesVal: "",
    }
    const [isOpenDeleteAlert, setisOpenDeleteAlert] = useState(false);
    const [sexualOrientationID, setSexualOrientationID] = useState();
    const [sexualOrientationValidationModal, setSexualOrientationValidationModal] = useState(ValidationModal)
    const [sexualOrientationSaveUpdateModal, setSexualOrientationSaveUpdateModal] = useState({})
    const [mainSexualOrientationModal, setMainSexualOrientationModal] = useState(SexualOrientation_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [onSexualOrientationSaved, setOnSexualOrientationSaved] = useState(false)
    const [del, setDel] = useState(false)
    // const [searchDropdown, setSearchDropdown] = useState(false);
    const [is, setIs] = useState(false);
    // console.log("AddNewProblem", props)

    useEffect(() => {
        // setPracticeID(PracticeID)
        if (sexualOrientationData.PatientID != null) {
            setDel(true)
            setSexualOrientationID(sexualOrientationData.PatientID)
        } else {
            if (!onSexualOrientationSaved) {
                setSexualOrientationID(0);
                setDel(false)
            } else {
                setDel(true)
            }
        }
    }, [sexualOrientationID])

    const SexualOrientationValidation = async () => {
        let notesVal = SexualOrientationData.find(item => item.display === mainSexualOrientationModal.SexualOrientation)?.value || "";

        let ValidationModal = {
            SexualOrientationVal: FormValidator(
                mainSexualOrientationModal.SexualOrientation,
                enumUtil.enumValidationType.Required,
                'Sexual Orientation',
            ),
            ...(notesVal === "Other" ?
                {
                    NotesVal: FormValidator(
                        mainSexualOrientationModal.Notes,
                        enumUtil.enumValidationType.Required,
                        'Notes',
                    )
                } : {})
        }
        await setSexualOrientationValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleSaveSexualOrientation = async () => {
        if(!IsEditAllowed) return;
        await SexualOrientationValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setSexualOrientationSaveUpdateModal(sexualOrientationSaveUpdateModal)
            let data = {
                PatientID: patientID,
                HistoryType: "Social History",
                HistorySubType: "Sexual Orientation",
                ...sexualOrientationSaveUpdateModal
            };

            let saveModal = {
                TableName: enumUtil.enumAPITableName.PatientHistory,
                ID: patientID,
                Data: { ...data },
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        NotificationHandler(`Record Saved Successfully`, enumUtil.enumtoaster.success)
                        setIsRecordSaved(true);
                        // setSexualOrientationID(response.id)
                        // setOnSexualOrientationSaved(true)
                        onClose()
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    console.log('error', error);
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }

    const handleChange = (e) => {
        let { name, value } = e.target
        let modal = { ...mainSexualOrientationModal };
        let saveModal = { ...sexualOrientationSaveUpdateModal }
        modal[name] = value
        setMainSexualOrientationModal(modal)
        for (var property in SexualOrientation_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setSexualOrientationSaveUpdateModal(saveModal)
    }

    const SexualOrientationName = () => {
        return (
            <p className="heading">Add New Sexual Orientation</p>
        )
    }
    const handleSelectedData = (selectedData, name, type, mode) => {
        setIs(true)
        let modal = { ...mainSexualOrientationModal };
        if (type === 'client' && !isNull(selectedData)) {
            if (name === "SexualOrientation") {
                modal[name] = selectedData.display
                sexualOrientationSaveUpdateModal[name] = selectedData.value + "";
                // setProviderID(selectedData.value + "")
            } else if (name === "ProviderID") {
                modal[name] = selectedData.display
                sexualOrientationSaveUpdateModal[name] = selectedData.value + "";
            }
        } else if (type === 'server' && !isNull(selectedData)) {


        } else {
            modal[name] = ''
            sexualOrientationSaveUpdateModal[name] = ''
        }
        setMainSexualOrientationModal(modal)
        return selectedData
    }
        const handleDeleteModal = () => {
            setisOpenDeleteAlert(true)
        }
        const onCloseDelete = () => {
            setisOpenDeleteAlert(false);
        }
        const onDelete = () => {
            setIsRecordSaved(true);
            setisOpenDeleteAlert(false);
            onClose();
        }
    
    let DeleteConfirmation = "";
    if (isOpenDeleteAlert) {
        DeleteConfirmation = (
            <DeleteConfirmatiom
                isOpenAlert={isOpenDeleteAlert}
                hideReason={true}
                API_URL={API_URL}
                TableName={enumUtil.enumAPITableName.SexualOrientation}
                ID={String(patientID)}
                onCloseDelete={onCloseDelete}
                onClose={onDelete}
            />
        );
    }
    let DeletePopup = "";
    if (del) {
        DeletePopup = (
            <button
                className={
                    props?.IsDeleteAllowed
                      ? 
                    "btn-icon-transparent"
                      : 
                      "btn-icon-transparent delete-btn-disabled"
                } onClick={handleDeleteModal}>
                <span className="icon"><i className="icon-delete"></i></span>
                <span className="title">Delete</span>
            </button>
        );
    }
    

    return (
        <Modal show={isOpenSexualOrientation} onHide={isOpenSexualOrientation} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_ehr_problems ar_new-popup-design">
            <Modal.Body>
            {isLoading ? <Loader/> : null}
            {DeleteConfirmation}
            {/* <ModalHeader HeaderName={SexualOrientationName} DeletePopup={''} isClosed={onClose} /> */}
            <ModalHeader HideAuditIcon={"PatEncounter"} HeaderName={SexualOrientationName} isOpenDeleteAlert={isOpenDeleteAlert} onCloseDelete={onCloseDelete} DeletePopup={DeletePopup} isClosed={onClose} />
                <div className="">
                    <div className=''>
                        <div className="input mb-12">
                            <div className="form-group input">
                                <label className="pb-3px">Sexual Orientation</label>
                                <div className={`input form-group ar-multiple-br m-0 ${sexualOrientationValidationModal.SexualOrientationVal ? 'error' : ''}`}>
                                    <SuperSearchList
                                        type="client"
                                        id='SexualOrientation'
                                        name='SexualOrientation'
                                        searchValue={mainSexualOrientationModal.SexualOrientation}
                                        data={SexualOrientationData}
                                        onChange={handleChange}
                                        getSelectedData={handleSelectedData}
                                        icon={'Simple'}
                                        sup_btn='sup_btn'
                                        sup_inp='superSearchVisitInp'
                                        inputError={sexualOrientationValidationModal.SexualOrientationVal}
                                    />
                                    {sexualOrientationValidationModal.SexualOrientationVal}
                                </div>
                            </div>
                        </div>
                        <div className={`input mb-0 ${sexualOrientationValidationModal.NotesVal ? 'error' : ''}`}>
                            <label className="pb-3px">Notes</label>
                            <textarea
                                className="form-control"
                                id='Notes'
                                name='Notes'
                                rows="3"
                                onChange={handleChange}
                                value={mainSexualOrientationModal.Notes}
                            />
                            {sexualOrientationValidationModal.NotesVal}
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-end gap-2">
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose}>Cancel</button>
                <button className={`btn btn-validate px-10 h-100 ${IsEditAllowed ? '' : 'disable'}`} onClick={handleSaveSexualOrientation}>Save</button>
            </div>
        </Modal>
    )
}

export default AddNewSexualOrientation